import React, { Fragment, useEffect, useState } from "react";
import { set_returns } from "../../../redux/actions/ReturnsAction";
import { connect } from "react-redux";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";
import Header from "../subheader/Header";
import { set_loading } from "../../../redux/actions/LayoutAction";
import TableList from "./TableList";
import "./returns.scss";

const Returns = (props) => {
  const [data, setData] = useState(false);
  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  const getReturns = (page) =>
    apiJson.returns.getReturns(page).then((response) => {
      if (response.success) {
        props.set_returns({
          returns: response.data.refunds,
          pagination: response.data.pagination,
        });
        setData(true);
      } else if (!response.status) {
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
        setData(true);
      } else {
        setData(true);
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });

  const pageChange = (page) => {
    setData(false);
    getReturns(page);
  };

  useEffect(() => {
    document.title = "Returns";
  }, []);

  useEffect(() => {
    getReturns(1);
    // eslint-disable-next-line
  }, []);

  // eslint-disable-next-line
  useEffect(() => props.set_loading(!data), [data]);
  return (
    <Fragment>
      <div className="vendor-page-right returns-page-desktop">
        <Header heading="Returns" search={false} filters={null} />
        {data && (
          <div className="right-content returns-page-content-container">
            <div className="content-container">
              <TableList
                List={props.returns}
                pageChange={pageChange}
                pagination={props.pagination}
              />
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProsps = (state) => {
  return {
    pagination: state.return.pagination,
    returns: state.return.returns,
    load: state.layout.isLoading,
  };
};

const mapDispatchToProps = { set_returns, set_loading };

export default connect(mapStateToProsps, mapDispatchToProps)(Returns);
